import moment from 'moment';
import { Row, Col, Badge } from 'reactstrap';
// import ChefAssign from '../../ChefAssign';
import Transaction from '../../TranstionTable';
// import ChefAssign from './ChefAssign'; // Adjust import as needed
// import Transaction from './Transaction'; // Adjust import as needed

type BookingAccordionDetailsProps = {
  booking: any; // ideally, replace `any` with the real booking type
  index: number;
  state: boolean; // or the type used in your state
  toggleState: (index: number) => void; // if it toggles a row at index
};


const BookingAccordionDetails: React.FC<BookingAccordionDetailsProps> = ({
  booking,
  index,
  // state,
  // toggleState,
}) => {
  return (
    <tr>
      <td colSpan={12} style={{ padding: 0 }}>
        <div className="accordion-content">
          <h6>Details</h6>
          <Row>
            <Col xs="2">
              <strong>Create Date</strong>
              <p>
                {moment(booking.createdAt, 'YYYY-MM-DD HH:mm:ss')
                  .format('DD/MM/YYYY, hh:mm A')
                  .toUpperCase() || 'N/A'}
              </p>
            </Col>
            <Col xs="1" className="seprator">|</Col>

            <Col xs="2">
              <strong>Requirement</strong>
              <p>
                {booking.requirement
                  ? booking.requirement.charAt(0).toUpperCase() + booking.requirement.slice(1)
                  : 'N/A'}
              </p>
            </Col>
            <Col xs="1" className="seprator">|</Col>

            <Col xs="2">
              {/* <ChefAssign
                booking={booking}
                index={index}
                state={state}
                 togglePopoverContent={(key) => toggleState(key as number)}
              /> */}
            </Col>
            <Col xs="1" className="seprator">|</Col>

            <Col xs="2">
              <strong>Menu</strong>
              <p>{booking.menu || 'N/A'}</p>
            </Col>
          </Row>

          <Row>
            <Col xs="5">
              <strong>Note</strong>
              <p>{booking.note || 'N/A'}</p>
            </Col>
            <Col xs="1" className="seprator">|</Col>
            <Col xs="2">
              <strong>Person</strong>
              <p>{booking.headCount || 'N/A'}</p>
            </Col>
          </Row>

          <Row>
            <Col xs="12">
              <strong>Ingredients</strong>
              <p>
                <i className="bi bi-eye"></i>
              </p>
            </Col>
          </Row>

          <h6>Payment</h6>
          <Row>
            <Col xs="2">
              <strong>Advanced Payment</strong>
              <p>
                {booking.payment?.advance || 'N/A'}{' '}
                <Badge className="payment-badge" color="light">Received</Badge>
              </p>
            </Col>
            <Col xs="2">
              <strong>Received Payment</strong>
              <p>
                {booking.payment?.received || 'N/A'}{' '}
                <Badge className="payment-pending-badge" color="light">Pending</Badge>
              </p>
            </Col>
            <Col xs="2">
              <strong>Total Payment</strong>
              <p>{booking.payment?.total || 'N/A'}</p>
            </Col>
            <Col xs="2">
              <strong>Discount</strong>
              <p>{booking.payment?.discount || 'N/A'}</p>
            </Col>
            <Col xs="2">
              <strong>Total Discount</strong>
              <p>{booking.payment?.discount || 'N/A'}</p>
            </Col>
            <Col xs="2">
              <strong>Receipt</strong>
              <p className="d-flex align-items-center">
                <i className="bi bi-download me-2"></i>
                <Transaction index={index} />
              </p>
            </Col>
          </Row>
        </div>
      </td>
    </tr>
  );
};

export default BookingAccordionDetails;